import { createContext, useContext, useState, ReactNode } from "react";
import { IAddressProps } from "interfaces/Address";
import { IBankingDataProps } from "interfaces/BankingData";
import { IContactProps } from "interfaces/Contact";
import { IPolicemanProps } from "interfaces/Policeman";
import { IUserToPolicemanProps } from "interfaces/User";
import { IVehicleProps } from "interfaces/Vehicle";

type PolicemanContextData = {
  user: IUserToPolicemanProps | undefined;
  setUser: (value: IUserToPolicemanProps) => void;
  policeman: IPolicemanProps | undefined;
  setPoliceman: (value: IPolicemanProps) => void;
  vehicle: IVehicleProps | undefined;
  setVehicle: (value: IVehicleProps) => void;
  contact: IContactProps | undefined;
  setContact: (value: IContactProps) => void;
  bankingData: IBankingDataProps | undefined;
  setBankingData: (value: IBankingDataProps) => void;
  address: IAddressProps | undefined;
  setAddress: (value: IAddressProps) => void;
};

type ContextProviderProps = {
  children: ReactNode;
};

export const PolicemanContext = createContext({} as PolicemanContextData);

export function PolicemanContextProvider({
  children,
}: ContextProviderProps): JSX.Element {
  const [user, setUser] = useState<IUserToPolicemanProps | undefined>();
  const [policeman, setPoliceman] = useState<IPolicemanProps | undefined>();
  const [vehicle, setVehicle] = useState<IVehicleProps | undefined>();
  const [contact, setContact] = useState<IContactProps | undefined>();
  const [address, setAddress] = useState<IAddressProps | undefined>();
  const [bankingData, setBankingData] = useState<
    IBankingDataProps | undefined
  >();

  return (
    <PolicemanContext.Provider
      value={{
        user,
        setUser,
        policeman,
        setPoliceman,
        vehicle,
        setVehicle,
        contact,
        setContact,
        bankingData,
        setBankingData,
        address,
        setAddress,
      }}
    >
      {children}
    </PolicemanContext.Provider>
  );
}

export const usePoliceman = () => {
  return useContext(PolicemanContext);
};
